import React, { FC } from 'react';

type UploadAudioInnerIconProps = {
  className?: string;
};

export const UploadAudioInnerIcon: FC<UploadAudioInnerIconProps> = ({ className }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden
  >
    <path
      d="M14.332 25.3307C15.1765 25.3307 15.8876 25.0418 16.4654 24.4641C17.0431 23.8863 17.332 23.1752 17.332 22.3307V17.3307H21.332V14.6641H15.9987V19.8307C15.7543 19.653 15.4934 19.525 15.216 19.4467C14.9387 19.3685 14.644 19.3298 14.332 19.3307C13.4876 19.3307 12.7765 19.6196 12.1987 20.1974C11.6209 20.7752 11.332 21.4863 11.332 22.3307C11.332 23.1752 11.6209 23.8863 12.1987 24.4641C12.7765 25.0418 13.4876 25.3307 14.332 25.3307ZM7.9987 29.3307C7.26536 29.3307 6.63781 29.0698 6.11603 28.5481C5.59425 28.0263 5.33292 27.3983 5.33203 26.6641V5.33073C5.33203 4.5974 5.59336 3.96984 6.11603 3.44806C6.6387 2.92628 7.26625 2.66495 7.9987 2.66406H18.6654L26.6654 10.6641V26.6641C26.6654 27.3974 26.4045 28.0254 25.8827 28.5481C25.3609 29.0707 24.7329 29.3316 23.9987 29.3307H7.9987ZM17.332 11.9974V5.33073H7.9987V26.6641H23.9987V11.9974H17.332Z"
      fill="white"
    />
  </svg>
);

export default UploadAudioInnerIcon;

